import React from "react";
import {
  Button,
  Card,
  CardActionArea,
  CardMedia,
  Divider,
  Grid,
  Typography,
} from "@mui/material";

function Education({ data }) {
  return (
    <>
      <div className="pt-2 pb-2">
        <h5>Last Education</h5>
        <div>
          <Typography color="primary" variant="h6">
            Name of University/School
          </Typography>
          <Typography variant="subtitle1" style={{ color: "#595959" }}>
            {data?.Education?.school_name}
          </Typography>
          <Typography color="primary" variant="h6">
            Qualification
          </Typography>
          <Typography variant="subtitle1" style={{ color: "#595959" }}>
            {data?.Education?.degree}
          </Typography>
          <Typography color="primary" variant="h6">
            Major
          </Typography>
          <Typography variant="subtitle1" style={{ color: "#595959" }}>
            {data?.Education?.major}
          </Typography>
          <Typography color="primary" variant="h6">
            IPK/Grade
          </Typography>
          <Typography variant="subtitle1" style={{ color: "#595959" }}>
            {data?.Education?.ipk}
          </Typography>
          <Typography color="primary" variant="h6">
            Start Year
          </Typography>
          <Typography variant="subtitle1" style={{ color: "#595959" }}>
            {data?.Education?.start_year}
          </Typography>
          <Typography color="primary" variant="h6">
            End Year
          </Typography>
          <Typography variant="subtitle1" style={{ color: "#595959" }}>
            {data?.Education.is_current === true
              ? "Present"
              : data?.Education?.graduate_year}
          </Typography>
        </div>
      </div>
      <Divider />
    </>
  );
}

export default Education;
